import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigateService {

  constructor(private _router: Router) { }

  public setUrl(path: string, params?: {}) {
    this._router.navigateByUrl(path, { replaceUrl: true, state: params });
  }

  public getParams(router: Router): any {
    return router.getCurrentNavigation()?.extras?.state;
  }
}
